import { Injectable, inject } from '@angular/core';

import { TaskService } from '../task.service';
import { TenantService } from '../tenant.service';
import { BaseSocketEventHandler } from './base-socket-event-handler';

interface TaskTypesUpdatedSocketEvent {
    eventDtoType: 'TaskTypesUpdated';
}

@Injectable({ providedIn: 'root' })
export class TaskTypesUpdatedSocketEventHandler extends BaseSocketEventHandler<TaskTypesUpdatedSocketEvent> {
    private tenantService = inject(TenantService);
    private taskService = inject(TaskService);

    protected eventDtoType(): string {
        return 'TaskTypesUpdated';
    }

    protected handleEvent = async (_: TaskTypesUpdatedSocketEvent): Promise<void> => {
        await this.tenantService.refreshConfig();
        await this.taskService.refreshTaskTypes();
    };
}
